module.exports = __webpack_public_path__ + "media/images/partners/moov-africa-238f78ef9c0fb20360c9aa78b75df9ff.jpeg";